export default function getResource(label, vars = []) {
    const resources = {
        selectYourSamplesText: 'Select your sample(s)',
        getText: 'Get ',
        freeSamplesWithEveryOrderText: ' free sample(s) with every order'
    };

    return resources[label];
}
